/**
 * Utilitaires pour les statistiques
 */

/**
 * Fusionne les flux selon une configuration de fusion
 * @param {Object} initialObj - Objet initial avec les données de flux
 * @param {Array} mergeConfig - Configuration de fusion avec referenceName et possibleNames
 * @returns {Object} - Objet avec les flux fusionnés
 */
export const mergeFluxes = (initialObj, mergeConfig) => {
  if (!initialObj || typeof initialObj !== "object") {
    return {};
  }

  const newObj = {};

  Object.keys(initialObj).forEach((key) => {
    newObj[key] = initialObj[key];
  });

  (Array.isArray(mergeConfig) ? mergeConfig : []).forEach((merge) => {
    const { referenceName, possibleNames } = merge;
    const names = Array.isArray(possibleNames) ? [...possibleNames] : [];

    if (newObj[referenceName] === undefined) {
      newObj[referenceName] = [];
    }

    const referenceIndex = names.indexOf(referenceName);
    if (referenceIndex > -1) {
      names.splice(referenceIndex, 1);
    }

    names.forEach((name) => {
      const obj = newObj[name];
      if (!obj) return;

      obj.forEach((elem) => {
        const existingElemIndex = newObj[referenceName].findIndex(
          (x) => x.flux === elem.flux,
        );
        if (existingElemIndex === -1) {
          newObj[referenceName].push({ ...elem });
        } else {
          newObj[referenceName][existingElemIndex].countAnomaly +=
            elem.countAnomaly;
        }
      });

      if (referenceName !== name) {
        delete newObj[name];
      }
    });

    if (newObj[referenceName].length === 0) {
      delete newObj[referenceName];
    }
  });

  return newObj;
};
